import React from 'react'
import classNames from 'classnames'

import styles from './DashboardWrapper.module.scss'

const DashboardWrapper = ({ children, hasBack, className }) => {
  return (
    <div className={classNames(styles.wrapper, { [styles.back]: hasBack }, className)}>
      {children}
    </div>
  )
}

export default DashboardWrapper
